import React from 'react';
//import React, { Suspense } from 'react';

import {
  BrowserRouter as Router,
  Route,
  Redirect,
  Switch
} from 'react-router-dom';

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import NewFile from './files/pages/NewFile';
import UserFiles from './files/pages/UserFiles';
import UserSharedFiles from './files/pages/UserSharedFiles';
import GetSharedFiles from './files/pages/GetSharedFiles';

import HomePage from './shared/pages/HomePage';

import EnterCodeForm from './shared/pages/EnterCodeForm';

import Auth from './user/pages/Auth';

import MainNavigation from './shared/components/Navigation/MainNavigation';
import { AuthContext } from './shared/context/auth-context';

import { useAuth } from './shared/hooks/auth-hook';

//import LoadingSpinner from './shared/components/UIElements/LoadingSpinner';

//const NewFile = React.lazy(() => import('./files/pages/NewFile'));
//const UserFiles = React.lazy(() => import('./files/pages/UserFiles'));
//const UserSharedFiles = React.lazy(() => import('./files/pages/UserSharedFiles'));
//const GetSharedFiles = React.lazy(() => import('./files/pages/GetSharedFiles'));
//const Auth = React.lazy(() => import('./user/pages/Auth'));

//const EnterCodeForm = React.lazy(() => import('./shared/pages/EnterCodeForm'));



const App = () => {
  const { token, login, logout, userId } = useAuth();

  let routes;

  if (token) {
    routes = (
      <Switch>
        <Route path="/:userId/shared" exact>
          <UserSharedFiles />
        </Route>
        <Route path="/:userId/files" exact>
          <UserFiles />
        </Route>
        <Route path="/files/new" exact>
          <NewFile />
        </Route>
        {/*<Redirect to="/" />*/}
        <Redirect to={`/${userId}/files`} />
      </Switch>
    );
  } else {
    routes = (
      <Switch>
        <Route path="/" exact>
          <HomePage />
        </Route>
        <Route path="/entercode" exact>
          <EnterCodeForm />
        </Route>
        <Route path="/shared/files" exact>
          <GetSharedFiles />
        </Route>
        <Route path="/auth">
          <Auth />
        </Route>
        <Redirect to="/auth" />
        {/*<Redirect to="/" />*/}
      </Switch>
    );
  }

  return (
    <AuthContext.Provider
      value={{
        isLoggedIn: !!token,
        token: token,
        userId: userId,
        login: login,
        logout: logout
      }}
    >
      <Router>
        <MainNavigation />
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          closeOnClick
          pauseOnHover
          draggable
          theme="colored"
        />
        <main>{routes}</main>
        {/*
        <main>
          <Suspense
            fallback={
              <div className="lazy-center">
                <LoadingSpinner />
              </div>
            }
          >
            {routes}
          </Suspense>
        </main>
        */}
      </Router>
    </AuthContext.Provider>
  );
};

export default App;
